/*
 * Points de pagination des carrousels de la page d'accueil.
 *
 * Le defilement lui-meme est natif (scroll-snap en CSS) : ce fichier ne fait
 * que refleter la position et permettre de sauter a une diapositive. Si le JS
 * ne s'execute pas, la piste reste defilable au doigt — les points sont un
 * confort, pas le mecanisme.
 */
/*
 * Bulles de la galerie.
 *
 * Sur grand ecran l'ouverture est entierement en CSS — un survol, le
 * JavaScript n'a rien a y faire. Il ne sert qu'a deux choses : la croix qui
 * referme sans quitter la vignette, et l'appui sur la pastille qui ouvre la
 * bulle sur telephone, ou il n'y a pas de survol.
 */
(function () {
  var cases = document.querySelectorAll('.bmb-galerie__case');
  if (!cases.length) return;

  var fermerTout = function (sauf) {
    cases.forEach(function (c) {
      if (c === sauf) return;
      c.classList.remove('est-ouverte');
      var p = c.querySelector('.bmb-galerie__pastille');
      if (p) p.setAttribute('aria-expanded', 'false');
    });
  };

  cases.forEach(function (caseGalerie) {
    var pastille = caseGalerie.querySelector('.bmb-galerie__pastille');
    var croix = caseGalerie.querySelector('.bmb-galerie__fermer');

    if (pastille) {
      pastille.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var ouverte = caseGalerie.classList.toggle('est-ouverte');
        pastille.setAttribute('aria-expanded', ouverte ? 'true' : 'false');
        /* Une seule bulle a la fois : sur un ecran etroit, deux bulles
           ouvertes se chevauchent. */
        if (ouverte) fermerTout(caseGalerie);
      });
    }

    if (croix) {
      croix.addEventListener('click', function (e) {
        /* La croix est posee au-dessus du lien qui couvre la vignette : sans
           cela, le clic traverserait et ouvrirait la fiche produit. */
        e.preventDefault();
        e.stopPropagation();
        caseGalerie.classList.add('est-fermee');
        caseGalerie.classList.remove('est-ouverte');
        if (pastille) pastille.setAttribute('aria-expanded', 'false');
      });
    }

    /* Sur grand ecran, l'etat ferme ne vaut que pour la visite en cours : la
       bulle se represente au survol suivant. */
    caseGalerie.addEventListener('mouseleave', function () {
      caseGalerie.classList.remove('est-fermee');
    });
  });

  /* Un appui ailleurs referme la bulle ouverte — sinon elle resterait posee
     sur la photo pendant tout le defilement. */
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('.bmb-galerie__case')) return;
    fermerTout(null);
  });
})();

(function () {
  var pistes = document.querySelectorAll('[data-bmb-piste]');
  if (!pistes.length) return;

  pistes.forEach(function (piste) {
    var points = document.querySelector('[data-bmb-points="' + piste.dataset.bmbPiste + '"]');
    if (!points) return;

    var cases = Array.prototype.slice.call(piste.children);
    if (cases.length < 2) {
      points.hidden = true;
      return;
    }

    /* La barre est construite ici et non dans le Liquid : quatre sections
       partagent ce carrousel, et le nombre de diapositives depend du contenu.
       Sans JavaScript, la piste reste defilable au doigt. */
    var CHEVRON_G = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" aria-hidden="true"><path d="m15 18-6-6 6-6" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    var CHEVRON_D = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" aria-hidden="true"><path d="m9 18 6-6-6-6" stroke-linecap="round" stroke-linejoin="round"/></svg>';

    points.innerHTML =
      '<div class="bmb-points__liste">' +
      cases
        .map(function (_, i) {
          return (
            '<button type="button" aria-label="Slide ' +
            (i + 1) +
            '"' +
            (i === 0 ? ' aria-current="true"' : '') +
            '></button>'
          );
        })
        .join('') +
      '</div>' +
      '<div class="bmb-points__fleches">' +
      '<button type="button" data-bmb-prec aria-label="Previous">' + CHEVRON_G + '</button>' +
      '<button type="button" data-bmb-suiv aria-label="Next">' + CHEVRON_D + '</button>' +
      '</div>';

    var boutons = Array.prototype.slice.call(points.querySelector('.bmb-points__liste').children);
    var prec = points.querySelector('[data-bmb-prec]');
    var suiv = points.querySelector('[data-bmb-suiv]');

    /* La diapositive courante est celle dont le centre est le plus proche du
       centre de la piste. Se fier a `scrollLeft / largeur` donnerait un
       resultat faux des que les cases n'ont pas toutes la meme largeur. */
    var indexCourant = function () {
      var centre = piste.scrollLeft + piste.clientWidth / 2;
      var proche = 0;
      var ecartMin = Infinity;
      cases.forEach(function (c, i) {
        var ecart = Math.abs(c.offsetLeft - piste.offsetLeft + c.clientWidth / 2 - centre);
        if (ecart < ecartMin) {
          ecartMin = ecart;
          proche = i;
        }
      });
      return proche;
    };

    var allerA = function (i) {
      var cible = Math.max(0, Math.min(cases.length - 1, i));
      piste.scrollTo({ left: cases[cible].offsetLeft - piste.offsetLeft, behavior: 'smooth' });
    };

    boutons.forEach(function (b, i) {
      b.addEventListener('click', function () {
        allerA(i);
      });
    });

    prec.addEventListener('click', function () {
      allerA(indexCourant() - 1);
    });

    suiv.addEventListener('click', function () {
      allerA(indexCourant() + 1);
    });

    var marquer = function () {
      var proche = indexCourant();
      boutons.forEach(function (b, i) {
        if (i === proche) {
          b.setAttribute('aria-current', 'true');
        } else {
          b.removeAttribute('aria-current');
        }
      });
      /* Bout de course : `scrollLeft` ne retombe pas toujours pile sur la
         derniere case, d'ou la tolerance d'un pixel. */
      prec.disabled = piste.scrollLeft <= 1;
      suiv.disabled = piste.scrollLeft >= piste.scrollWidth - piste.clientWidth - 1;
    };

    var attente;
    piste.addEventListener(
      'scroll',
      function () {
        window.cancelAnimationFrame(attente);
        attente = window.requestAnimationFrame(marquer);
      },
      { passive: true }
    );

    marquer();
  });
})();
